import { render } from "./ProviderJobResultCard.vue?vue&type=template&id=756a1796&scoped=true"
import script from "./ProviderJobResultCard.vue?vue&type=script&lang=js"
export * from "./ProviderJobResultCard.vue?vue&type=script&lang=js"

import "./ProviderJobResultCard.vue?vue&type=style&index=0&id=756a1796&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756a1796"]])

export default __exports__